const form = document.querySelector("#size-checker")
function whichRollator(e, t) {
  switch (!0) {
    case 1 == t:
      return "Wide Track"
    case e < 63:
      return "Compact Track"
    case e >= 63:
      return "Regular Track"
    default:
      return "Wide  catch all Track"
  }
}
form &&
  form.addEventListener("submit", function (e) {
    e.preventDefault()
    let t = form.elements["hip-inches"],
      r = form.elements["height-feet"],
      a = whichRollator(parseFloat(r.value), t.value),
      n = document.getElementById("ultralight-recommendation")
    ;(n.innerHTML = `We recommend a <b>${a}</b> based on a user that is ${
      r.options[r.selectedIndex].text
    } tall and their hips are ${
      t.options[t.selectedIndex].text
    } in circumference.`),
      n.classList.add("show")
  })
